import { render, staticRenderFns } from "./ShiftTeachers.vue?vue&type=template&id=5137e59d&lang=pug&"
import script from "./ShiftTeachers.vue?vue&type=script&lang=js&"
export * from "./ShiftTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports